import script from "./ProfileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileView.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=b8e15a74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8e15a74"]])

export default __exports__